exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-cmp .header-navbar .navbar-wrapper .navbar-header {\n  width: 450px !important; }\n\n.login-cmp .no-padding {\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/anonymous/login/login.component.scss
// module id = ../../../../../src/app/anonymous/login/login.component.scss
// module chunks = main